import * as types from "../constants/actionTypes";

import { REHYDRATE } from 'redux-persist';
import Cookies from "cookies-js";
import { getDomain } from "../helpers/Tools";
//import { BrowserRouter } from "react-router-dom";

export const ssoInitialState = function () {
    return {
        userDetails: {},
        userName: "",
        userEmail: "",
        isLoggedIn: false,
        verifiedLogin: false,
        isLoggingIn: false,
        hpConsentList: []
    };
};


export default function ssoReducer(state = ssoInitialState(), action) {
    var myDomain = getDomain();
    switch (action.type) {
        case types.HP_CONSENT_LIST:
            //debugger;
            return {
                ...state,
                hpConsentList: action.consentList
            };
        case types.REVOKE_HP_FHIR_GRANT_SUCCESS:
            let hpConsentList = state.hpConsentList;
            let newHpConsentList = hpConsentList.filter(listItem => {
                return listItem.key !== action.consent.key
            })
            return {
                ...state,
                hpConsentList: newHpConsentList
            };
        case types.USER_AUTHENTICATE_ISLOGGEDIN:
            return {
                ...state,
                isFetching: false
            }
        case types.USER_AUTHENTICATE:
            return {
                ...state,
                isFetching: true,
                isLogginedIn: true,
            };


        case types.UPDATE_TOKEN_AND_REFRESH_TOKEN:
            //debugger;
            return {
                ...state, 
                userDetails: { ...state.userDetails,
                                expires_in: action.tokenExpiresIn,
                                expiresDate: action.tokenExpires,
                                dateLoaded: action.tokenLoaded
                            }
            };
        case types.USER_AUTHENTICATE_SUCCESS:
            const userData = action.userData;
            const displayName = (userData.Givenname || userData.GivenName) + ' ' + userData.Surname;
            const epid = userData.EPID;
            const mychart = userData.MyChartID;
            //debugger;
            return {
                ...state,
                userDetails: userData,
                LogoutMessage: null,
                isLoggedIn: userData !== null && userData.access_token !== null,
                loginError: action.responseError,
                isFetching: action.isWaiting,
                primaryUser: { displayName: displayName, epid: epid, myChartId: "" + mychart },
                isLoggingIn: false,
            };
        //case types.USER_AUTHENTICATE_REFRESH:
        //    debugger;
        //    return { ...state, isFetching: true };
        case types.VERIFY_LOGIN_COMPLETED:
            //debugger;
            return { ...state, verifiedLogin: true };
        case types.LOGOUT:
            //debugger;
            return {
                ...ssoInitialState(),
                LogoutMessage: null,
                verifiedLogin: state.verifiedLogin
            };
        case types.AJAX_CALL_ERROR:
            return { ...state, isFetching: false, error: action.error };
        case types.USER_AUTHENTICATE_FAILURE:
            return {
                ...state,
                isLoggedIn: false,
                userDetails: {},
                LogoutMessage: null,
                loginError: action.responseError,
                errorCode: action.errorCode,
                userErrorMessage: action.userErrorMessage,
                isFetching: false,
                isLoggingIn: false,
            };
        case types.SET_REDIRECT_URL:
            return { ...state, reDirectURL: action.URL };
        case types.UPDATE_PATIENT_IDS:
            const primaryUser = state.primaryUser;
            primaryUser.externalId = action;
            return { ...state, primaryUser: primaryUser };
        case REHYDRATE:
            //console.log("SSO Rehydrating... state = " + JSON.stringify( state) + "  action = " + JSON.stringify( action));
            //let oRet = action.payload && action.payload.sso ? action.payload.sso : state;
            //console.log("SSO Rehydrating... returning = " + JSON.stringify( oRet)) ;
            return { ...state };
        //return oRet ;
        default:
            return { ...state };
    }
}
